module.exports = __webpack_public_path__ + "static/media/aitam.48f1003e.png";